import React from 'react';

export type MetadadosPaginacao = {
  pagina: number;
  limite: number;
  total: number;
  total_paginas: number;
  tem_anterior: boolean;
  tem_proxima: boolean;
};

export const paginacaoVazia: MetadadosPaginacao = {
  pagina: 1,
  limite: 20,
  total: 0,
  total_paginas: 0,
  tem_anterior: false,
  tem_proxima: false
};

type Props = {
  paginacao: MetadadosPaginacao;
  aoMudarPagina: (pagina: number) => void;
  carregando?: boolean;
};

const Paginacao: React.FC<Props> = ({ paginacao, aoMudarPagina, carregando = false }) => (
  <nav className="pagination-controls" aria-label="Paginação">
    <button className="botao botao-secundario" type="button" disabled={carregando || !paginacao.tem_anterior} onClick={() => aoMudarPagina(paginacao.pagina - 1)}>
      Anterior
    </button>
    <span>Página {paginacao.pagina} de {Math.max(1, paginacao.total_paginas)} · {paginacao.total} resultado(s)</span>
    <button className="botao botao-secundario" type="button" disabled={carregando || !paginacao.tem_proxima} onClick={() => aoMudarPagina(paginacao.pagina + 1)}>
      Próxima
    </button>
  </nav>
);

export default Paginacao;
